import { ReactNode } from 'react';

import { SecondaryTab } from 'modules/common/components/SecondaryTab';

import { useChainTypeTabStyles } from './useChainTypeTabStyles';

export interface ChainTypeTabProps {
  isLast?: boolean;
  isSelected: boolean;
  label: ReactNode | string;
  className?: string;
  onClick?: () => void;
}

export const ChainTypeTab = ({
  className,
  isLast,
  isSelected,
  label,
  onClick,
}: ChainTypeTabProps) => {
  const { classes, cx } = useChainTypeTabStyles();

  return (
    <SecondaryTab
      className={cx(classes.root, className)}
      isLast={isLast}
      isSelected={isSelected}
      label={label}
      onClick={onClick}
    />
  );
};
